import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITripdavisorReviews } from '@core/models/tripadvisor';

@Injectable()
export class TripadvisorService {
  constructor(private http: HttpClient) {}

  public getReviews(hotelId): Observable<ITripdavisorReviews> {
    return this.http.get<ITripdavisorReviews>(`hotels/async/tripadvisor/${hotelId}`);
  }
}
